// extracted by mini-css-extract-plugin
module.exports = {"size":"tag-rarity_size__1EmT6","size--18":"tag-rarity_size--18__zU4CW","size--14":"tag-rarity_size--14__sexFL"};